"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _reactUse = require("react-use");

var _services = require("@alycecom/services");

var _recipient = require("../../store/recipient/recipient.selectors");

var _giftingOnTheFly = require("../../store/giftingOnTheFly.selectors");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    input: {
      borderRadius: 5
    },
    button: {
      backgroundColor: palette.green.dark,
      color: palette.common.white,
      '&.MuiButton-contained:hover': {
        backgroundColor: palette.green.mountainMeadowDark
      },
      '&.Mui-disabled, &.MuiButton-contained:hover.Mui-disabled': {
        backgroundColor: palette.grey.timberWolf
      }
    },
    hint: {
      fontSize: 14,
      lineHeight: '17px',
      color: palette.green.fruitSaladLight
    },
    hintItalic: {
      fontSize: 14,
      lineHeight: '17px',
      color: palette.green.fruitSaladLight,
      fontStyle: 'italic'
    }
  };
});

var CopyLinkStep = function CopyLinkStep() {
  var classes = useStyles();
  var giftLink = (0, _reactRedux.useSelector)(_giftingOnTheFly.getContactGiftLink);
  var isRecipientsAdded = (0, _reactRedux.useSelector)(_recipient.getIsRecipientsAdded);
  var isGiftLinkVisible = isRecipientsAdded && Boolean(giftLink);

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var _useCopyToClipboard = (0, _reactUse.useCopyToClipboard)(),
      _useCopyToClipboard2 = (0, _slicedToArray2.default)(_useCopyToClipboard, 2),
      copy = _useCopyToClipboard2[1];

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  var handleCopyLink = (0, _react.useCallback)(function () {
    if (giftLink) {
      copy(giftLink);
      showGlobalMessage({
        type: _services.MessageType.Success,
        text: 'Link copied'
      });
      trackEvent('Activate link — copied', {
        feature: 'GOTF'
      });
    }
  }, [copy, giftLink, showGlobalMessage, trackEvent]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White-Bold"
  }, "Step 3: Copy link & send to recipient"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    label: "Gift Link",
    fullWidth: true,
    variant: "filled",
    className: classes.input,
    disabled: true,
    InputLabelProps: {
      shrink: isGiftLinkVisible
    },
    inputProps: {
      'data-testid': 'GiftingOnTheFly.GiftLink'
    },
    value: isGiftLinkVisible ? giftLink : ''
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: handleCopyLink,
    disabled: !isGiftLinkVisible,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      color: "inherit",
      icon: "copy"
    }),
    fullWidth: true,
    variant: "contained",
    className: classes.button,
    "data-testid": "GiftingOnTheFly.CopyGiftLink"
  }, "Copy Link")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.hint
  }, "Copy and paste these unique gift links into your messages to recipients."), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.hintItalic
  }, "For optimal conversion, we recommend incorporating the messages into your existing engagement cadences and leveraging at least 2-3 outreach attempts leveraging channels like email, LinkedIn and phone calls."))));
};

var _default = /*#__PURE__*/(0, _react.memo)(CopyLinkStep);

exports.default = _default;